import React, { useState } from "react";

// import utils
import { routes } from "../utils/routes";
import { Link, useLocation } from "react-router-dom";
import { icon } from "../utils/icons";

const Sidebar = ({ navHeight, showSidebar }) => {
  const [collapse, setCollapse] = useState([]); // for show/hide subroutes group
  const path = useLocation(); // check location for activated

  // show / hide sub-routes group
  const toggleCollapse = (id) => {
    if (collapse.includes(id)) {
      setCollapse(collapse.filter((c) => c !== id));
    } else {
      setCollapse([...collapse, id]);
    }
  };
  return (
    <div
      style={{
        height: `calc(100vh - ${navHeight}px)`,
      }}
      className={`${
        showSidebar ? "translate-x-0" : "translate-x-full"
      } sidebar transition-all start-0 flex flex-col justify-between  lg:translate-x-0 w-[250px] overflow-y-auto hide scrollbar-hide  bg-primary-color-500 absolute top-full p-4 text-white`}
    >
      <ul className=" text-[1rem] md:text-lg">
        {routes.map((r) => {
          if (r?.children) {
            return (
              <li key={r.id}>
                <div
                  onClick={() => toggleCollapse(r.id)}
                  className="p-1 cursor-pointer flex items-center rounded-lg justify-between transition-all   hover:bg-secondry-color-500 hover:text-primary-color-500"
                >
                  <div className="flex items-center">
                    <p className="me-1">{r.icon}</p>
                    {r.name}
                  </div>
                  <p
                    className={`transition-all ${
                      collapse.includes(r.id)
                        ? "rotate-90"
                        : "rotate-0 rtl:-rotate-180"
                    }`}
                  >
                    {icon.chevronR}
                  </p>
                </div>
                <ul
                  className={`py-1 px-2 overflow-hidden  transition-all ${
                    collapse.includes(r.id)
                      ? "h-full opacity-1"
                      : "h-0 opacity-0"
                  }`}
                >
                  {r.children
                    .filter((c) => c.type.includes("collapse"))
                    .map((c) => (
                      <li
                        key={c.id}
                        className={`${
                          c.path === path.pathname
                            ? "bg-secondry-color-400 text-primary-color-500"
                            : ""
                        } mb-1 transition-all  rounded-lg hover:bg-secondry-color-500 hover:text-primary-color-500`}
                      >
                        <Link to={c.path} className="p-1 flex items-center">
                          <p className="me-1">{c.icon}</p>
                          {c.name}
                        </Link>
                      </li>
                    ))}
                </ul>
              </li>
            );
          }
          return (
            <li
              key={r.id}
              className={`${
                r.path === path.pathname
                  ? "bg-secondry-color-500 text-primary-color-500"
                  : ""
              } transition-all  hover:bg-secondry-color-500  rounded-lg hover:text-primary-color-500 mb-1`}
            >
              <Link to={r.path} className="flex rounded-lg items-center p-1">
                <p className="me-1">{r.icon}</p>
                {r.name}
              </Link>
            </li>
          );
        })}
      </ul>
      <div className="p-1 ">
        <p>لوحة تحكم اصدار 1.1.5</p>
      </div>
    </div>
  );
};

export default Sidebar;
